import * as React from 'react';
import { MagnifyingGlass } from 'react-loader-spinner';

export const MagnifyingGlassCustom = () => {
  return (
    <MagnifyingGlass
      visible={true}
      height="120"
      width="120"
      ariaLabel="MagnifyingGlass-loading"
      wrapperStyle={{}}
      wrapperClass="MagnifyingGlass-wrapper"
      glassColor="#c0efff"
      color="#7a858d"
    />
  );
};
